export class NoLeftNodeException {
    constructor(alias) {
        this.name = `NoLeftNodeException`
        this.message = `No left node has been defined`
    }
}

export class NoRightNodeException {
    constructor(alias) {
        this.name = `NoRightNodeException`
        this.message = `No node at right side of relationship`
    }
}

export class DuplicateAliasException {
    constructor(alias) {
        this.name = `AliasException`
        this.message = `${alias} is already defined as an alias`
    }
}

export class NoReturnException {
    constructor() {
        this.name = `ReturnException`
        this.message = `No return property specified`
    }
}

export class InvalidReturnFormatException {
    constructor() {
        this.name = `InvalidReturnStatementFormat`
        this.message = `Value provided should be in format [{alias: value, property: value}]`
    }
}

export class InvalidClauseFormatException {
    constructor() {
        this.name = `InvalidClauseFormatException`
        this.message = `Value provided should be in format [{alias: value, property: value, clause: value, value: value}]`
    }
}

export class ReturnAlreadyDefinedException {
    constructor() {
        this.name = `ReturnAlreadyDefinedException`
        this.message = `Return has already been defined in this query`
    }
}

export class AliasDoesNotExistException {
    constructor() {
        this.name = `AliasDoesNotExistException`
        this.message = `This alias does not exist inside the query`
    }
}


export default class Tql {

    constructor() {
        this.leftNodeIndex = 1
        this.relationshipIndex = 2
        this.rightNodeIndex = 3
        this.returnIndex = 7
        this.whereIndex = 4
        this.clauseIndex = 5
        this.aliases = []
        this.query = [`MATCH `, ``, ``, ``, ``, ``, ` RETURN `, ``];
    }

    registerAlias(alias) {
        this.aliases.push(alias)
    }

    validateAlias(alias) {
        if (!this.aliases.includes(alias)) {
            return false
        }
        return true
    }

    hasLeftNode() {
        if (this.query[this.leftNodeIndex] === "") {
            return false;
        } else {
            return true;
        }
    }

    /*
    * addLeftNode appends the left node to the query
    * (NODE:N)
    */
    addLeftNode(nodeType, alias) {
        this.registerAlias(alias)
        this.query[this.leftNodeIndex] = `(${nodeType}:${alias})`
        return this
    }

    /*
    * addRightNode appends the right node to the query
    * (NODE:N)
    */
    addRightNode(nodeType, alias) {
        this.registerAlias(alias)
        this.query[this.rightNodeIndex] = `(${nodeType}:${alias})`
        return this
    }

    /*
    * addLeftRelationship appends a relationship from the right node
    * to the left node <-[RELATIONSHIP:R]-
    */
    addLeftRelationship(relationship, alias) {
        this.registerAlias(alias)
        this.query[this.relationshipIndex] = `<-[${relationship}:${alias}]-`
        return this
    }

    /*
    * addLeftRelationship appends a relationship from the left node
    * to the right node -[RELATIONSHIP:R]->
    */
    addRightRelationship(relationship, alias) {
        this.registerAlias(alias);
        this.query[this.relationshipIndex] = `-[${relationship}:${alias}]->`
        return this
    }

    /*
     * addReturn appends return statements to the query
     * returnStatement should be in the format [`s`,`h`]
     */
    addReturn(returnStatements) {
        let statementsToReturn = [];

        if (Array.isArray(returnStatements)) {
            returnStatements.forEach(statement => {
                if (statement.alias !== undefined && statement.property !== undefined) {
                    if (!this.validateAlias(statement.alias)) {
                        throw new AliasDoesNotExistException()
                    }
                    statementsToReturn.push(`${statement.alias}.${statement.property}`);
                } else {
                    statementsToReturn.push(statement);
                }
            });
        } else {
            throw new InvalidReturnFormatException()
        }

        this.query[this.returnIndex] = statementsToReturn.join(", ");
        return this
    }

    /*
     * addClause appends clauses to the query, clauses should be in the
     * format [{alias: value, property: value, clause: value, value: value}]
     */
    addClause(clauses) {
        if (!clauses.constructor === Array) {
            throw new InvalidReturnFormatException()
        }

        clauses = clauses.map((clause) => {
            if (clause.alias && clause.property && clause.clause && clause.value != null) {
                if (!this.validateAlias(clause.alias)) {
                    throw new AliasDoesNotExistException()
                }
                return `${clause.alias}.${clause.property} ${clause.clause} "${clause.value}"`
            } else {
                throw new InvalidClauseFormatException()
            }
        })

        this.query[this.whereIndex] = " WHERE "
        this.query[this.clauseIndex] = clauses.join(" AND ")
        return this
    }

    resetClauses() {
        this.query[this.whereIndex] = "";
        this.query[this.clauseIndex] = "";
    }

    resetRightNode() {
        this.query[this.rightNodeIndex] = "";
    }

    resetRelationship() {
        this.query[this.relationshipIndex] = "";
    }

    resetleftNode() {
        this.query[this.leftNodeIndex] = "";
    }

    resetReturn() {
        this.query[this.returnIndex] = "";
    }

    /*
    * Apply specific rules to the query before build
    */
    validate() {
        //There must always be a left node
        if(!this.query[this.leftNodeIndex]) {
            throw new NoLeftNodeException()
        }

        //if there is a relationship
        if(this.query[this.relationshipIndex]){
            //there must be right node
            if(!this.query[this.rightNodeIndex]){
                throw new NoRightNodeException()
            }
        }

        //There must always be a return
        if(!this.query[this.returnIndex]){
            throw new NoReturnException()
        }
    }

    build() {
        this.validate()
        return this.query.join("")
    }

}


// WEBPACK FOOTER //
// ./src/tql/Tql.js